export default "__VITE_ASSET__sIrzVpJH__"